import { render, staticRenderFns } from "./FitModelNewEdit.vue?vue&type=template&id=1064415a"
import script from "./FitModelNewEdit.vue?vue&type=script&lang=js"
export * from "./FitModelNewEdit.vue?vue&type=script&lang=js"
import style0 from "./FitModelNewEdit.vue?vue&type=style&index=0&id=1064415a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports